export default __webpack_public_path__ + "static/media/avatar22.5d66accb.png";